import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import React, { useContext, useEffect, useState } from "react";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import { Paginator } from "primereact/paginator";
import { Dialog } from "primereact/dialog";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

import { useDispatch } from "react-redux";
import UiContext from "../../store/ui-context";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { DataTable } from "primereact/datatable";
import {
  genTemplateBodyAction,
  genTemplateBodyDate,
  genTemplateBodyNumber,
  genTemplateBodyText,
} from "../../components/utils/TableTemplateBodyGenerator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import createFilterText from "../../utils/CreateFilterText";
import HistoriPembayaranEditorDialog from "./HistoriPembayaranEditorDialog.js";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";

const title = "Histori Pembayaran Kendaraan";
const fetchOrderBy = "tanggal_bayar";
const fetchOrderMethod = "DESC";
const apiUrl = "kendaraanpembayaran";

const editorDefaultValue = {
  kendaraan_id: null,
  diproses_id: null,
  tipe: "",
  tahun: "",
  jumlah: 0,
  tanggal_bayar: "",
  status: 0,
  keterangan: "",
};

const editTitle = "Histori Pembayaran Kendaraan";
const addTitle = "Tambah Pembayaran";

const HistoriPembayaranDialog = (props) => {
  const { visible, onHide, pembayaranType, data, setData } = props;

  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const { loading: editorLoading, requestPost: editorRequestPost } =
    useAPIRequest();

  const [firstLoad, setFirstLoad] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    take: 10,
    filter: "",
    total: 0,
  });
  const [listData, setListData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const [addNewMode, setAddNewMode] = useState(false);
  const [editorError, setEditorError] = useState({});
  const [editorDialogShowed, setEditorDialogShowed] = useState(false);

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  useEffect(() => {
    if (visible) {
      fetchListData({
        page: 1,
        take: 10,
      });
    }
  }, [visible]);

  // API call section

  const fetchListData = async ({ page, take, filter }) => {
    if (loading) return;

    const _filter = filter ?? getFilter();

    return requestGet({
      fullUrl: `/api/transaksi/${apiUrl}/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: fetchOrderBy,
        order_method: fetchOrderMethod,
        with_kendaraan: 1,
        with_diproses: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListData(data);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchData = async ({ id }) => {
    if (loading) return;
    return requestGetOne({
      fullUrl: `/api/transaksi/${apiUrl}/one/${id}`,
      onSuccess: ({ message, data }) => {},
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async ({ ids }) => {
    if (loading) return;

    return requestDelete({
      fullUrl: `/api/transaksi/${apiUrl}/delete`,
      ids: ids,
      onSuccess: ({ message, data }) => {
        const newListData = listData.filter((el) => !ids.includes(el.id));
        setListData(newListData);
        uiContext.showSuccessMsg("Success", message);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveData = async ({ data }) => {
    resetEditorError();
    if (loading) return;
    const valid = validateData();

    if (valid) {
      const body = convertSaveData(data);

      return editorRequestPost({
        fullUrl: `/api/transaksi/${apiUrl}/save`,
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
          setEditorError(data);
        },
        onSuccess: ({ data: responseData, message }) => {
          uiContext.showSuccessMsg("Success", message);
        },
      });
    }
    return null;
  };

  // methods & functions section

  const getFilter = () => {
    return "kendaraan_id:=:" + data.id + ";tipe:=:" + pembayaranType;
  };

  const resetEditorError = () => {
    setEditorError({});
  };

  const validateData = () => {
    let valid = true;

    return valid;
  };

  const convertSaveData = (data) => {
    return data;
  };

  // handle UI events section

  const handleOnReload = async () => {
    fetchListData({
      page: 1,
      take: paging.take,
    });
  };

  const handleOnFilter = (filterMap) => {
    const filterString = createFilterText(filterMap);
    setPaging({ ...paging, filter: filterString });
    fetchListData({
      page: 1,
      take: 10,
      filter: filterString,
    });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnDelete = (row) => {
    resetEditorError();
    const accept = async () => {
      if (loading) return;

      await deleteData({ ids: [row.id] });
    };
    const reject = () => {};

    confirmDialog({
      message: "Menghapus 1 data, lanjutkan?",
      header: "Konfirmasi",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleDeleteMultiple = () => {
    resetEditorError();

    if (selectedData.length > 0) {
      const accept = async () => {
        if (loading) return;

        const listIds = selectedData.map((el) => el.id);
        await deleteData({ ids: listIds });
        setSelectedData([]);
      };
      const reject = () => {};

      confirmDialog({
        message: `Menghapus ${selectedData.length} data, lanjutkan?`,
        header: "Konfirmasi",
        icon: "pi pi-exclamation-triangle",
        acceptClassName: "p-button-danger",
        accept,
        reject,
      });
    }
  };

  const validate = () => {
    let valid = true;
    let newEror = {};

    return valid;
  };

  const handleOnAddNew = () => {
    setAddNewMode(true);
    resetEditorError();
    setSelectedData({ ...editorDefaultValue });
    setEditorDialogShowed(true);
  };

  const handleOnEdit = async (row) => {
    setAddNewMode(false);
    resetEditorError();
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setSelectedData({ ...newData });
      setEditorDialogShowed(true);
    }
  };

  const handleConfirmEditor = async (data) => {
    const newData = await saveData({ data });
    if (newData) {
      if (addNewMode) {
        setListData([newData, ...listData]);
      } else {
        const index = listData.findIndex((el) => el.id === newData.id);
        const newListData = [...listData];
        newListData.splice(index, 1, newData);
        setListData(newListData);
      }
      setEditorDialogShowed(false);
    }
  };

  // UI section

  /**
   * Generate Table Column
   *
   * various function to generate
   * genTemplateBodyAction({ row, onEdit, onDelete })
   * genTemplateBodyText({ row, field, defaultEmpty })
   * genTemplateBodyNumber({ row, field, defaultEmpty, maxFraction, minFraction })
   * genTemplateBodyDate({ row, field, format })
   * genTemplateBodyImage({ row, field })
   */
  const actionBodyTemplate = (row) =>
    genTemplateBodyAction({
      row,
      onEdit: (row) => handleOnEdit(row),
      onDelete: handleOnDelete,
    });

  const tahunBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "tahun" });
  const tanggalBayarBodyTemplate = (row) =>
    genTemplateBodyDate({ row, field: "tanggal_bayar" });
  const jumlahBodyTemplate = (row) =>
    genTemplateBodyNumber({ row, field: "jumlah" });

  return (
    <Dialog
      visible={visible}
      style={{ width: "50rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      onHide={onHide}
    >
      <HistoriPembayaranEditorDialog
        pembayaranType={pembayaranType}
        data_kendaraan={data}
        data={selectedData}
        setData={setSelectedData}
        loading={editorLoading}
        error={editorError}
        setError={setEditorError}
        visible={editorDialogShowed}
        onHide={() => setEditorDialogShowed(false)}
        onConfirm={handleConfirmEditor}
      />

      <div className="col-center-center w-100 gap-3">
        {/* DATA MOBIL */}

        <div className="row-start-start w-full gap-4">
          <div className="col-start-start gap-1">
            <label className="font-bold text-sm text-slate-500">
              Nomor Polisi
            </label>
            <InputText
              className={`w-full`}
              value={data.nomor_polisi}
              disabled
            />
          </div>
          <div className="col-start-start gap-1">
            <label className="font-bold text-sm text-slate-500">
              Jenis Mobil
            </label>
            <InputText className={`w-full`} value={data.jenis_mobil} disabled />
          </div>
        </div>

        <Divider className="!my-2" />

        <div className={`row-between-center gap-2 w-100 pt-1`}>
          <div className="row-start-center gap-2">
            <Button
              className="w-[10rem]"
              icon="pi pi-plus"
              label="Tambah Baru"
              onClick={handleOnAddNew}
            />
            <Button
              className="w-[7rem]"
              disabled={selectedData.length === 0}
              icon="pi pi-trash"
              severity="danger"
              text
              label="Hapus"
              onClick={handleDeleteMultiple}
            />
          </div>
          <div className="row-start-center">
            <Button
              rounded
              outlined
              icon="pi pi-refresh"
              onClick={handleOnReload}
              style={{ width: "40px", height: "40px" }}
            />
          </div>
        </div>

        <div className={`row-center-center gap-2 w-100`}>
          <DataTable
            dataKey="id"
            className="w-100"
            loading={loading}
            showGridlines
            stripedRows
            editMode="cell"
            value={listData}
            selection={selectedData}
            onSelectionChange={(e) => setSelectedData(e.value)}
          >
            <Column headerClassName="w-[3rem]" selectionMode={"multiple"} />

            <Column
              header="Action"
              alignHeader={"center"}
              headerClassName="w-[9rem]"
              body={actionBodyTemplate}
            />
            <Column
              header="Tahun"
              headerClassName=""
              body={tahunBodyTemplate}
            />
            <Column
              header="Tanggal Bayar"
              headerClassName=""
              align={"right"}
              body={tanggalBayarBodyTemplate}
            />
            <Column header="Jumlah" body={jumlahBodyTemplate} />
          </DataTable>
        </div>

        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
        />
      </div>
    </Dialog>
  );
};

export default HistoriPembayaranDialog;
